import { render, staticRenderFns } from "./TableDocumentsPro.vue?vue&type=template&id=3e10e280&scoped=true&"
import script from "./TableDocumentsPro.vue?vue&type=script&lang=js&"
export * from "./TableDocumentsPro.vue?vue&type=script&lang=js&"
import style0 from "./TableDocumentsPro.vue?vue&type=style&index=0&id=3e10e280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e10e280",
  null
  
)

export default component.exports